var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/auth-login/components/login-page.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { logIn, verifyCredentials, switchAccount } from 'soapbox/actions/auth';
import { fetchInstance } from 'soapbox/actions/instance';
import { closeModal } from 'soapbox/actions/modals';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
import { getRedirectUrl } from 'soapbox/utils/redirect';
import { isStandalone } from 'soapbox/utils/state';
import LoginForm from './login-form';
import OtpAuthForm from './otp-auth-form';

const LoginPage = () => {
  const dispatch = useAppDispatch();
  const me = useAppSelector(state => state.me);
  const standalone = useAppSelector(state => isStandalone(state));
  const token = new URLSearchParams(window.location.search).get('token');
  const [isLoading, setIsLoading] = useState(false);
  const [mfaAuthNeeded, setMfaAuthNeeded] = useState(!!token);
  const [mfaToken, setMfaToken] = useState(token || '');
  const [shouldRedirect, setShouldRedirect] = useState(false);

  const getFormData = form => {
    return Object.fromEntries(Array.from(form).map(i => [i.name, i.value]));
  };

  const handleSubmit = event => {
    const {
      username,
      password
    } = getFormData(event.target);
    dispatch(logIn(username, password)).then(_ref => {
      let {
        access_token
      } = _ref;
      return dispatch(verifyCredentials(access_token)) // Refetch the instance for authenticated fetch
      .then(() => dispatch(fetchInstance()));
    }).then(account => {
      dispatch(closeModal());
      setShouldRedirect(true);

      if (typeof me === 'string') {
        dispatch(switchAccount(account.id));
      }
    }).catch(error => {
      var _error$response;

      const data = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data;

      if ((data === null || data === void 0 ? void 0 : data.error) === 'mfa_required') {
        setMfaAuthNeeded(true);
        setMfaToken(data.mfa_token);
      }

      setIsLoading(false);
    });
    setIsLoading(true);
    event.preventDefault();
  };

  if (standalone) return /*#__PURE__*/React.createElement(Redirect, {
    to: "/login/external",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 26
    }
  });

  if (shouldRedirect) {
    const redirectUri = getRedirectUrl();
    return /*#__PURE__*/React.createElement(Redirect, {
      to: redirectUri,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 12
      }
    });
  }

  if (mfaAuthNeeded) return /*#__PURE__*/React.createElement(OtpAuthForm, {
    mfa_token: mfaToken,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 29
    }
  });
  return /*#__PURE__*/React.createElement(LoginForm, {
    handleSubmit: handleSubmit,
    isLoading: isLoading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 10
    }
  });
};

export default LoginPage;